import { ShieldCheck, BadgeCheck, Users } from "lucide-react";
import { IMAGES, VALUES } from "@/data/site";
import Reveal from "@/components/Reveal";
import Pillars from "@/components/Pillars";
import CTASection from "@/components/CTASection";
import PageHeader, { Eyebrow, usePageTitle } from "@/components/PageHeader";

const ICONS = [ShieldCheck, BadgeCheck, Users];

export default function ChiSiamo() {
  usePageTitle("/chi-siamo");
  return (
    <main data-testid="chi-siamo-page">
      <PageHeader
        testId="chi-siamo-header"
        eyebrow="Chi siamo"
        title="Dal 2009"
        lead="Magit di Gianfrancesco Maurizio S.r.l. nasce dall'esperienza sul campo e dalla passione per l'impiantistica fatta bene. Non improvvisiamo: progettiamo."
      />
      <section className="bg-ink">
        <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-14 px-6 py-24 md:px-12 md:py-32 lg:grid-cols-2">
          <Reveal className="relative overflow-hidden rounded-xl border border-white/10">
            <img src={IMAGES.napoli} alt="Napoli — sede operativa Magit" className="h-full min-h-[360px] w-full object-cover opacity-80" />
            <span className="absolute bottom-5 left-5 rounded-full border border-white/15 bg-ink/70 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/80 backdrop-blur">
              Napoli — Italia
            </span>
          </Reveal>
          <Reveal delay={150}>
            <Eyebrow>La nostra storia</Eyebrow>
            <div className="space-y-6 text-base leading-relaxed text-white/65 md:text-lg">
              <p>
                Da oltre quindici anni operiamo in tutta Italia realizzando impianti elettrici e di climatizzazione
                per privati, aziende ed enti pubblici.
              </p>
              <p>
                La nostra specializzazione più distintiva è la manutenzione dei poligoni di tiro: un servizio tecnico e
                certificato che ci rende un punto di riferimento unico sul territorio.
              </p>
              <p>
                Crediamo che ogni impianto nasca da un progetto: analizziamo, dimensioniamo e documentiamo prima di
                intervenire, per consegnare soluzioni durature e conformi.
              </p>
            </div>
            <div className="mt-12 space-y-6">
              {VALUES.map((v, i) => {
                const Icon = ICONS[i];
                return (
                  <div key={v.title} data-testid={`value-${i}`} className="flex gap-5 border-t border-white/10 pt-6">
                    <Icon className="mt-1 h-6 w-6 shrink-0 text-brand" />
                    <div>
                      <h3 className="font-display text-xl font-bold uppercase text-white">{v.title}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-white/55">{v.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </section>
      <div className="border-t border-white/10">
        <Pillars />
      </div>
      <CTASection />
    </main>
  );
}
